import { axios, formatError } from './utils';

export async function getApplication(applicationId: number): Promise<any> {
  try {
    const response = await axios.get(`/api/applications/${applicationId}`);
    return response.data.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
}

export async function updateTotalScore(
  applicationId: number,
  totalScore: number | null,
  sessionId: string
) {
  try {
    const response = await axios.patch(`/api/applications/${applicationId}/total-score`, {
      totalScore,
      sessionId,
    });
    return response.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
}

export async function updateApplicationReview(
  applicationId: number,
  submissionQuestionsAnswers: { id: number; question: string; answer: string; score: number }[],
  status: string
) {
  try {
    const response = await axios.put(`/api/applications/${applicationId}`, {
      submissionQuestionsAnswers,
      status,
      sessionId: crypto.randomUUID(),
    });
    return response.data.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
}

export async function requestApplicationChanges(
  applicationId: number,
  feedback: string,
  changesDueAt?: string
) {
  try {
    const response = await axios.post(`/api/applications/${applicationId}/request-changes`, {
      feedback,
      changesDueAt,
    });
    return response.data.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
}

export async function updateChangeRequestStatus(
  applicationId: number,
  changeRequestId: number,
  status: string
) {
  try {
    const response = await axios.put(
      `/api/applications/${applicationId}/change-requests/${changeRequestId}`,
      { status }
    );
    return response.data.data;
  } catch (error) {
    const err = formatError(error);
    throw err;
  }
}
